export function CallingPaymentData() {
  return [
    {
      value: 'all',
      title: 'All'
    },
    {
      value: 'Yes',
      title: 'Yes'
    },
    {
      value: 'No',
      title: 'No'
    }
  ];
}

export function FlowUnblockOrder() {
  return [
    {
      value: 'Web',
      title: 'Flow Web'
    },
    {
      value: 'Print',
      title: 'Flow Print'
    }
  ];
}

export function EMSType() {
  return [
    {
      value: '1',
      title: 'ซองจดหมายขนาดเล็ก'
    },
    {
      value: '2',
      title: 'ซองหน้าต่าง'
    },
    {
      value: '3',
      title: 'แบบหลายที่อยู่'
    }
  ];
}

export function EMSAddress() {
  return [
    {
      value: 'Customer',
      title: 'Customer'
    },
    {
      value: 'PresentBill',
      title: 'Present Bill'
    },
    {
      value: 'CNDN',
      title: 'CN/DN'
    },
    {
      value: 'ReceivePO',
      title: 'Receive PO'
    },
    {
      value: 'ReceiptCheque',
      title: 'Receipt Cheque'
    },
    {
      value: 'SendReceipt',
      title: 'Send Receipt'
    },
    {
      value: 'WHT',
      title: 'WHT'
    }
  ];
}

export function BankPayment() {
  return [
    {
      value: 'KBANK',
      title: 'KBANK'
    },
    {
      value: 'SCB',
      title: 'SCB'
    },
    {
      value: 'BBL',
      title: 'BBL'
    },
    {
      value: 'SCBT',
      title: 'SCBT'
    }
  ];
}

export function OverallStatus() {
  return [
    {
      value: 'WaitingDoc',
      title: 'Waiting Doc'
    },
    {
      value: 'WaitingSendOS',
      title: 'Waiting OS Plan'
    },
    { value: 'WaitingCreateBillPresentment', title: 'Waiting Create Bill Presentment' },
    {
      value: 'WaitingPresentBill',
      title: 'Waiting Present Bill'
    },
    {
      value: 'WaitingPayment',
      title: 'Waiting Payment'
    },
    {
      value: 'WaitingMatching',
      title: 'Waiting Matching'
    },
    {
      value: 'IncomingPayment',
      title: 'Incoming Payment'
    },
    {
      value: 'Completed',
      title: 'Completed (Paid)'
    },
    {
      value: 'CompletedSystem',
      title: 'Completed (Paid) By System'
    },
    {
      value: 'Cancel',
      title: 'Cancelled'
    }
  ];
}
export function PlanCashStatus() {
  return [
    {
      value: 'WaitForConfirm',
      title: 'Wait For Confirm'
    },
    {
      value: 'Confirmed',
      title: 'Confirmed'
    },
    {
      value: 'AlreadySendToAFMS',
      title: 'Already Send to AFMS'
    }
  ];
}
export function PaymentStatus() {
  return [
    {
      value: 'Open',
      title: 'Open'
    },
    {
      value: 'ConfirmPayment',
      title: 'Confirm Payment'
    },
    {
      value: 'IncomingPayment',
      title: 'Incoming Payment'
    },
    {
      value: 'PaymentSuccess',
      title: 'Payment Success'
    }
  ];
}
export function PaymentStatusIncomming() {
  return [
    {
      value: 'Open',
      title: 'Open'
    },
    {
      value: 'ConfirmPayment',
      title: 'Confirm Payment'
    },
    {
      value: 'Cancelled',
      title: 'Cancelled'
    },
    {
      value: 'IncomingPayment',
      title: 'Incoming Payment'
    },
    {
      value: 'PaymentSuccess',
      title: 'Payment Success'
    },
    {
      value: 'Failed',
      title: 'Failed'
    },
    {
      value: 'Reversed',
      title: 'Reversed'
    },
    {
      value: 'ReverseSuccess',
      title: 'Reverse Success'
    }
  ];
}

export function PostType() {
  return [
    {
      value: 'Auto',
      title: 'Auto'
    },
    {
      value: 'Manual',
      title: 'Manual'
    }
  ];
}

export function OverdueStatus() {
  return [
    {
      value: 'WaitingOverdue',
      title: 'Waiting Overdue'
    },
    {
      value: 'Overdue',
      title: 'Overdue'
    },
    {
      value: 'ProblemOverCusdue',
      title: 'Problem Over Cusdue'
    },
    {
      value: 'ProblemOverdue',
      title: 'Problem Overdue'
    },
    {
      value: 'No',
      title: 'No'
    }
  ];
}

export function StatusBill() {
  return [
    {
      value: 'WaitingDoc',
      title: 'Waiting Doc'
    },
    {
      value: 'WaitingSendOS',
      title: 'Waiting Send OS'
    },
    {
      value: 'WaitingPresentBill',
      title: 'Waiting Present Bill'
    },
    {
      value: 'ProblemBill',
      title: 'Problem Bill'
    },
    {
      value: 'Completed',
      title: 'Complete Bill'
    }
  ];
}
export function StatusBillFllowingPayment() {
  return [
    {
      value: 'Waiting',
      title: 'Waiting Doc'
    },
    {
      value: 'WaitingSendOS',
      title: 'Waiting Send OS'
    },
    {
      value: 'WaitingPresentBill',
      title: 'Waiting Present Bill'
    },
    {
      value: 'ProblemBill',
      title: 'Problem Bill'
    },
    {
      value: 'Completed',
      title: 'Complete Bill'
    }
  ];
}

export function StatusOverdue() {
  return [
    {
      value: 'Waiting Overdue',
      title: 'Waiting Overdue'
    },
    {
      value: 'Overdue',
      title: 'Overdue'
    },
    {
      value: 'Problem Over Cusdue',
      title: 'Problem Over Cusdue'
    },
    {
      value: 'Problem Overdue',
      title: 'Problem Overdue'
    },
    {
      value: 'No',
      title: 'No'
    }
  ];
}

export function DocumentType() {
  return [
    {
      value: 'InvoiceNo',
      title: 'Invoice No.'
    },
    {
      value: 'BillPresentmentNo',
      title: 'Bill Presentment No'
    },
    {
      value: 'ReceiptNo',
      title: 'Receipt No'
    }
  ];
}
export function DocumentTypeExport() {
  return [
    {
      value: 'InvoiceNoZf2',
      title: 'Invoice'
    },
    {
      value: 'InvoiceNoZf8',
      title: 'Invoice No. ZF8'
    },
    {
      value: 'InvoiceNoZf9',
      title: 'Invoice No. ZF9'
    },
    {
      value: 'BillPresentmentNo',
      title: 'Bill No.'
    },
    {
      value: 'ReceiptNo',
      title: 'Receipt No'
    },
    {
      value: 'EO',
      title: 'EO'
    },
    {
      value: 'PI',
      title: 'PI'
    }
  ];
}
export function DocumentTypeOutsource() {
  return [
    {
      value: 'InvoiceNo',
      title: 'Invoice No.'
    },
    {
      value: 'BillPresentmentNo',
      title: 'Bill Presentment No'
    },
    {
      value: 'ReceiptNo',
      title: 'Receipt No'
    },
    {
      value: 'BENo',
      title: 'B/E No.'
    },
    {
      value: 'DLCNo',
      title: 'DLC No.'
    },
    {
      value: 'DPNo',
      title: 'DP No.'
    },
    {
      value: 'PONo',
      title: 'PO No.'
    },
    {
      value: 'ChequeNo',
      title: 'Cheque No.'
    }
  ];
}

export function DocumentTypeEMS() {
  return [
    {
      value: 'InvoiceNo',
      title: 'Invoice No.'
    },
    {
      value: 'BillPresentmentNo',
      title: 'Bill Presentment No'
    },
    {
      value: 'ReceiptNo',
      title: 'Receipt No'
    },
    {
      value: 'BENo',
      title: 'B/E No.'
    },
    {
      value: 'DLCNo',
      title: 'DLC No.'
    },
    {
      value: 'DPNo',
      title: 'DP No.'
    },
    {
      value: 'PONo',
      title: 'PO No.'
    },
    {
      value: 'ChequeNo',
      title: 'Cheque No.'
    },
    {
      value: 'TransactionNo',
      title: 'Transaction No.'
    },
    {
      value: 'CoversheetEMS',
      title: 'Coversheet EMS'
    }
  ];
}

export function DocumentTypePo() {
  return [
    {
      value: 'InvoiceNo',
      title: 'Invoice No.'
    },
    {
      value: 'PONo',
      title: 'PO No.'
    },
    {
      value: 'DPNo',
      title: 'DP No.'
    }
  ];
}

export function DocumentTypeInvoiceAndBill() {
  return [
    {
      value: 'Invoice',
      title: 'Invoice'
    },
    {
      value: 'DP',
      title: 'DP'
    },
    {
      value: 'BillingNo',
      title: 'Billing No'
    }
  ];
}

export function SelectTypeDate() {
  return [
    {
      value: 'Cus Due',
      title: 'Cus Due'
    },
    {
      value: 'Pay Date',
      title: 'Pay Date'
    },
    {
      value: 'Bill Presentment Date',
      title: 'Bill Presentment Date'
    },
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Bill Presentment Print Date',
      title: 'Bill Presentment Print Date'
    },
    {
      value: 'Due Date',
      title: 'Due Date'
    },
    {
      value: 'YBill',
      title: 'YBill'
    },
    {
      value: 'YCol',
      title: 'YCol'
    },
    {
      value: 'YCol Notify Date',
      title: 'YCol Notify Date'
    },
    {
      value: 'YCal',
      title: 'YCal'
    },
    {
      value: 'YCal Notify Date',
      title: 'YCal Notify Date'
    }
  ];
}
export function SelectTypeDatePayment() {
  return [
    {
      value: 'Cus Due',
      title: 'Cus Due'
    },
    {
      value: 'Pay Date',
      title: 'Pay Date'
    },
    {
      value: 'Issue Date',
      title: 'Issue Date'
    },
    {
      value: 'Bill Presentment Date',
      title: 'Bill Presentment Date'
    },
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Bill Presentment Print Date',
      title: 'Bill Presentment Print Date'
    },
    {
      value: 'Due Date',
      title: 'Due Date'
    },
    {
      value: 'Plan Cash Date',
      title: 'Plan Cash Date'
    },
    {
      value: 'YBill',
      title: 'YBill'
    },
    {
      value: 'YCol',
      title: 'YCol'
    },
    {
      value: 'YCol Notify Date',
      title: 'YCol Notify Date'
    },
    {
      value: 'YCal',
      title: 'YCal'
    },
    {
      value: 'YCal Notify Date',
      title: 'YCal Notify Date'
    }
  ];
}
export function SelectTypeDatePaymentExport() {
  return [
    {
      value: 'Cus Due',
      title: 'Cus Due'
    },
    {
      value: 'Pay Date',
      title: 'Pay Date'
    },
    {
      value: 'Bill Presentment Date',
      title: 'Bill Presentment Date'
    },
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Due Date',
      title: 'Due Date'
    },
    {
      value: 'YBill',
      title: 'YBill'
    },
    {
      value: 'YCol',
      title: 'YCol'
    },
    {
      value: 'YColNotifyDate',
      title: 'YCol Notify Date'
    },
    {
      value: 'YCal',
      title: 'YCal'
    },
    {
      value: 'YCalNotifyDate',
      title: 'YCal Notify Date'
    },
    {
      value: 'SapEtd',
      title: 'SAP ETD'
    },
    {
      value: 'SapEta',
      title: 'SAP ETA'
    },
    {
      value: 'AtdDate',
      title: 'ATD'
    }
  ];
}

export function StatusCallingPayment() {
  return [
    {
      value: 'Open',
      title: 'Open'
    },
    {
      value: 'ConfirmPayment',
      title: 'Confirm Payment'
    },
    {
      value: 'WaitingOSConfirm',
      title: 'Waiting OS Confirm'
    },
    {
      value: 'Confirm OS',
      title: 'Confirm OS'
    },
    {
      value: 'WaitingBUConfirm',
      title: 'Waiting BU Confirm'
    },
    {
      value: 'ConfirmBU',
      title: 'Confirm BU'
    }
  ];
}

export function StatusInvoiceAndBill() {
  return [
    {
      value: 'MissMatch',
      title: 'Miss Match'
    },
    {
      value: 'PendingLogistic',
      title: 'Pending Logistic'
    },
    {
      value: 'PendingWH',
      title: 'Pending WH'
    },
    {
      value: 'PendingCredit',
      title: 'Pending Credit'
    },
    {
      value: 'AlreadySent',
      title: 'Already Sent'
    },
    {
      value: 'Completed',
      title: 'Completed'
    }
  ];
}
export function FlowCompleteByStatus() {
  return [
    {
      value: 'WH',
      title: 'WH'
    },
    {
      value: 'Credit',
      title: 'Credit'
    }
  ];
}
export function AttachDPStatus() {
  return [
    {
      value: '1',
      title: 'แนบ DP'
    },
    {
      value: '2',
      title: 'ไม่แนบ DP'
    }
  ];
}

export function SelectTypeDateInvoice() {
  return [
    {
      value: 'Document Date',
      title: 'Document Date'
    },
    {
      value: 'Due Date',
      title: 'Due Date'
    },
    {
      value: 'YBill',
      title: 'YBill'
    },
    {
      value: 'YBill Notify Date',
      title: 'YBill Notify Date'
    },
    {
      value: 'YBill Notify Follow Invoice',
      title: 'YBill Notify Follow Invoice'
    },
    {
      value: 'YCol',
      title: 'YCol'
    },
    {
      value: 'YCol Notify Date',
      title: 'YCol Notify Date'
    },
    {
      value: 'YCal',
      title: 'YCal'
    },
    {
      value: 'YCal Notify Date',
      title: 'YCal Notify Date'
    },
    {
      value: 'Lead Time',
      title: 'Lead Time'
    },
    {
      value: 'ApproveDate',
      title: 'Approve Inv&DP Date'
    }
  ];
}
export function SelectTypeFollowingPo() {
  return [
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Due Date',
      title: 'Due Date'
    },
    {
      value: 'Lead Time',
      title: 'Lead Time'
    },
    {
      value: 'YBill',
      title: 'YBill'
    },
    {
      value: 'YBill Notify Date',
      title: 'YBill Notify Date'
    },
    {
      value: 'YBill Notify Follow Invoice',
      title: 'YBill Notify Follow Invoice'
    },
    {
      value: 'YCol',
      title: 'YCol'
    },
    {
      value: 'YCol Notify Date',
      title: 'YCol Notify Date'
    },
    {
      value: 'YCal',
      title: 'YCal'
    },
    {
      value: 'YCal Notify Date',
      title: 'YCal Notify Date'
    }
  ];
}
export function SelectTypeFollowingInvoice() {
  return [
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Due Date',
      title: 'Due Date'
    },
    {
      value: 'Lead Time',
      title: 'Lead Time'
    },
    {
      value: 'Cutoff Document Date to OS',
      title: 'Cutoff Document Date to OS'
    },
    {
      value: 'Bill Presentment Date',
      title: 'Bill Presentment Date'
    },
    {
      value: 'Receipt Date',
      title: 'Receipt Date'
    },
    {
      value: 'YBill',
      title: 'YBill'
    },
    {
      value: 'YBill Notify Date',
      title: 'YBill Notify Date'
    },
    {
      value: 'YBill Notify Follow Invoice',
      title: 'YBill Notify Follow Invoice'
    },
    {
      value: 'YCol',
      title: 'YCol'
    },
    {
      value: 'YCol Notify Date',
      title: 'YCol Notify Date'
    },
    {
      value: 'YCal',
      title: 'YCal'
    },
    {
      value: 'YCal Notify Date',
      title: 'YCal Notify Date'
    },
    {
      value: 'New YBill',
      title: 'New YBill'
    }
  ];
}
export function SelectTypeReceipt() {
  return [
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Due Date',
      title: 'Due Date'
    },
    {
      value: 'Cutoff Document Date to OS',
      title: 'Cutoff Document Date to OS'
    },
    {
      value: 'Bill Presentment Date',
      title: 'Bill Presentment Date'
    },
    {
      value: 'Receipt Date',
      title: 'Receipt Date'
    },
    {
      value: 'Send Date',
      title: 'Send Date'
    },
    {
      value: 'YBill',
      title: 'YBill'
    },
    {
      value: 'YCol',
      title: 'YCol'
    },
    {
      value: 'YCol Notify Date',
      title: 'YCol Notify Date'
    },
    {
      value: 'YCal',
      title: 'YCal'
    },
    {
      value: 'YCal Notify Date',
      title: 'YCal Notify Date'
    },
    {
      value: 'Created Date',
      title: 'Created Date'
    }
  ];
}
export function SelectConfirmPresentBillByEmail() {
  return [
    {
      value: 'Yes',
      title: 'Yes'
    },
    {
      value: 'No',
      title: 'No'
    }
  ];
}
export function SelectTypeFollowingOS() {
  return [
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Bill Presentment Date',
      title: 'Bill Presentment Date'
    },
    {
      value: 'Cutoff Date',
      title: 'Cutoff Date'
    },
    {
      value: 'Send Date',
      title: 'Send Date'
    },
    {
      value: 'Cheque Date',
      title: 'Cheque Date'
    },
    {
      value: 'Document Date',
      title: 'Document Date'
    },
    {
      value: 'YBill',
      title: 'YBill'
    },
    {
      value: 'YBill Notify Date',
      title: 'YBill Notify Date'
    },
    {
      value: 'YCol',
      title: 'YCol'
    },
    {
      value: 'YCol Notify Date',
      title: 'YCol Notify Date'
    },
    {
      value: 'YCal',
      title: 'YCal'
    },
    {
      value: 'YCal Notify Date',
      title: 'YCal Notify Date'
    },
    {
      value: 'New YBill',
      title: 'New YBill'
    },
    {
      value: 'Receipt Date',
      title: 'Receipt Date'
    },
    {
      value: 'ApproveDate',
      title: 'Approve Inv&DP Date'
    }
  ];
}
export function SelectTypeEMS() {
  return [
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Bill Presentment Date',
      title: 'Bill Presentment Date'
    },
    {
      value: 'Cutoff Date',
      title: 'Cutoff Date'
    },
    {
      value: 'Send Date',
      title: 'Send Date'
    },
    {
      value: 'Cheque Date',
      title: 'Cheque Date'
    },
    {
      value: 'Document Date',
      title: 'Document Date'
    },
    {
      value: 'YBill',
      title: 'YBill'
    },
    {
      value: 'YBill Notify Date',
      title: 'YBill Notify Date'
    },
    {
      value: 'YCol',
      title: 'YCol'
    },
    {
      value: 'YCol Notify Date',
      title: 'YCol Notify Date'
    },
    {
      value: 'YCal',
      title: 'YCal'
    },
    {
      value: 'YCal Notify Date',
      title: 'YCal Notify Date'
    },
    {
      value: 'New YBill',
      title: 'New YBill'
    },
    {
      value: 'Pay Date',
      title: 'Pay Date'
    },
    {
      value: 'Receipt Date',
      title: 'Receipt Date'
    },
    {
      value: 'ApproveDate',
      title: 'Approve Inv&DP Date'
    }
  ];
}
export function StatusDocumentOS() {
  return [
    {
      value: 'Waiting',
      title: 'Waiting'
    },
    {
      value: 'Completed',
      title: 'Completed'
    }
  ];
}
export function StatusSelectOS() {
  return [
    {
      value: 'New',
      title: 'New'
    },
    {
      value: 'Confirmed',
      title: 'Confirmed'
    },
    {
      value: 'AlreadySend',
      title: 'Already Sent'
    },
    {
      value: 'Completed',
      title: 'Completed'
    },
    {
      value: 'CompletedSystem',
      title: 'Completed (By System)'
    }
  ];
}
export function StatusEmailEms() {
  return [
    {
      value: 'New',
      title: 'New'
    },
    {
      value: 'Confirmed',
      title: 'Confirmed'
    },
    {
      value: 'AlreadySend',
      title: 'Already Sent'
    },
    {
      value: 'Completed',
      title: 'Completed'
    },
    {
      value: 'CompletedSystem',
      title: 'Completed (By System)'
    }
  ];
}
export function StatusSelect() {
  return [
    {
      value: 'New',
      title: 'New'
    },
    {
      value: 'Confirmed',
      title: 'Confirmed'
    },
    {
      value: 'AlreadySend',
      title: 'Already Sent'
    },
    {
      value: 'Completed',
      title: 'Completed'
    }
  ];
}
export function SelectTypeFollowingBU() {
  return [
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Due Date',
      title: 'Due Date'
    },
    {
      value: 'YBill',
      title: 'YBill'
    },
    {
      value: 'YBill Notify Date',
      title: 'YBill Notify Date'
    },
    {
      value: 'YBill Notify Follow Invoice',
      title: 'YBill Notify Follow Invoice'
    },
    {
      value: 'YCol',
      title: 'YCol'
    },
    {
      value: 'YCol Notify Date',
      title: 'YCol Notify Date'
    },
    {
      value: 'YCal',
      title: 'YCal'
    },
    {
      value: 'YCal Notify Date',
      title: 'YCal Notify Date'
    },
    {
      value: 'Document Date',
      title: 'Document Date'
    },
    {
      value: 'New YBill',
      title: 'New YBill'
    },
    {
      value: 'Receipt Date',
      title: 'Receipt Date'
    },
    {
      value: 'ApproveDate',
      title: 'Approve Inv&DP Date'
    }
  ];
}
export function SelectTypeDocumentTypeSearchProblem() {
  return [
    // {
    //   value: 'InvoiceNo',
    //   title: 'Invoice No.'
    // },
    // {
    //   value: 'ReceiptNo',
    //   title: 'Receipt No'
    // }
    {
      value: 'ReportNo',
      title: 'Report No.'
    }
  ];
}

export function SelectTypeDateTypeSearchProblem() {
  return [
    // {
    //   value: 'InvoiceDate',
    //   title: 'Invoice Date'
    // },
    {
      value: 'Duedate',
      title: 'Cus Due date'
    },
    {
      value: 'NextDate',
      title: 'Next Pay Date'
    },
    {
      value: 'OverdueDate',
      title: 'Overdue Date'
    }
  ];
}

export function SelectTypeOverdueDay() {
  return [
    {
      value: '0-15',
      title: '0-15'
    },
    {
      value: '16-30',
      title: '16-30'
    },
    {
      value: '31-60',
      title: '31-60'
    },
    {
      value: '61-90',
      title: '61-90'
    },
    {
      value: '>90',
      title: 'มากกว่า 90'
    }
  ];
}

export function SelectTypeNextPayDate() {
  return [
    {
      value: 'มีนัด',
      title: 'มีนัด'
    },
    {
      value: 'ไม่มีนัด',
      title: 'ไม่มีนัด'
    }
  ];
}

export function SelectTypeProblemType() {
  return [
    {
      value: '',
      title: 'All'
    },
    {
      value: 'ProblemBill',
      title: 'Problem Bill'
    },
    {
      value: 'ProblemPayment',
      title: 'Problem Payment'
    }
  ];
}

export function SelectTypeCountry() {
  return [
    {
      value: 'Domestic',
      title: 'Domestic'
    },
    {
      value: 'Export',
      title: 'Export'
    }
  ];
}

export function SelectTypeStatusProblemReport() {
  return [
    {
      value: 'Draft',
      title: 'Draft',
      isBill: true,
      isOverdue: true,
      isExport: true
    },
    {
      value: 'Open',
      title: 'Open',
      isBill: true,
      isOverdue: true,
      isExport: true
    },
    {
      value: 'OpenPDC',
      title: 'Open(PDC)',
      isBill: false,
      isOverdue: true,
      isExport: true
    },
    {
      value: 'Partial',
      title: 'Partial',
      isBill: true,
      isOverdue: true,
      isExport: true
    },
    {
      value: 'Closed',
      title: 'Closed',
      isBill: true,
      isOverdue: false,
      isExport: true
    },
    // {
    //   value: 'Closed1',
    //   title: 'Closed(มีค่าล่าช้า)',
    //   isBill: false,
    //   isOverdue: true,
    //   isExport: false
    // },
    // {
    //   value: 'Closed2',
    //   title: 'Closed(ไม่มีค่าล่าช้า)',
    //   isBill: false,
    //   isOverdue: true,
    //   isExport: false
    // },
    {
      value: 'Generate',
      title: 'Generate',
      isBill: false,
      isOverdue: true,
      isExport: false
    },
    {
      value: 'Cancelled',
      title: 'Cancelled',
      isBill: true,
      isOverdue: true,
      isExport: true
    }
  ];
}
export function SelectTypeStatusProblemReportBill() {
  return [
    {
      value: 'Draft',
      title: 'Draft',
      isBill: true,
      isOverdue: true,
      isExport: true
    },
    {
      value: 'Open',
      title: 'Open',
      isBill: true,
      isOverdue: true
    },
    {
      value: 'Partial',
      title: 'Partial',
      isBill: true,
      isOverdue: true
    },
    {
      value: 'Closed',
      title: 'Closed',
      isBill: true,
      isOverdue: false
    },
    {
      value: 'Cancelled',
      title: 'Cancelled',
      isBill: true,
      isOverdue: true
    }
  ];
}
export function SelectTypeStatusProblemReportPayment() {
  return [
    {
      value: 'Draft',
      title: 'Draft',
      isBill: true,
      isOverdue: true,
      isExport: true
    },
    {
      value: 'Open',
      title: 'Open',
      isBill: true,
      isOverdue: true
    },
    {
      value: 'Partial',
      title: 'Partial',
      isBill: true,
      isOverdue: true
    },
    {
      value: 'Closed1',
      title: 'Closed(มีค่าล่าช้า)',
      isBill: false,
      isOverdue: true
    },
    {
      value: 'Closed2',
      title: 'Closed(ไม่มีค่าล่าช้า)',
      isBill: false,
      isOverdue: true
    },
    {
      value: 'Generate',
      title: 'Generate',
      isBill: false,
      isOverdue: true
    },
    {
      value: 'Cancelled',
      title: 'Cancelled',
      isBill: true,
      isOverdue: true
    }
  ];
}
export function SelectTypeStatusProblemReportExport() {
  return [
    {
      value: 'Draft',
      title: 'Draft'
    },
    {
      value: 'Open',
      title: 'Open'
    },
    {
      value: 'OpenPDC',
      title: 'Open(PDC)'
    },
    {
      value: 'Partial',
      title: 'Partial'
    },
    {
      value: 'WaitingCreditAdvice',
      title: 'Waiting Credit Advice'
    },
    {
      value: 'WaitingConfirmCreditAdvice',
      title: 'Waiting Confirm Credit Advice'
    },
    {
      value: 'Closed',
      title: 'Closed'
    },
    {
      value: 'Cancelled',
      title: 'Cancelled'
    }
  ];
}
export function StatusFollowingInvoice() {
  return [
    {
      value: 'WaitingDoc',
      title: 'Waiting Doc'
    },
    {
      value: 'WaitingSendOS',
      title: 'Waiting Send OS'
    },
    {
      value: 'WaitingPresentBill',
      title: 'Waiting Present Bill'
    },
    {
      value: 'ProblemBill',
      title: 'Problem Bill'
    },
    {
      value: 'CompleteBill',
      title: 'Complete Bill'
    }
  ];
}

export function IncomingPaymentType() {
  return [
    {
      value: '0',
      title: 'B/E'
    },
    {
      value: '1',
      title: 'PDC'
    },
    {
      value: '2',
      title: 'Clearing'
    },
    {
      value: '10',
      title: 'Clearing (OS/BU)'
    },
    {
      value: '3',
      title: 'Transfer'
    },
    {
      value: '4',
      title: 'Net หนี้ - AP : GL Suspense Account for Adjustment'
    },
    {
      value: '5',
      title: 'Net หนี้: ตั้งยอดรอเงิน Net หนี้'
    },
    {
      value: '9',
      title: 'Cheque Return'
    }
  ];
}

export function IncomingExportPaymentType() {
  return [
    {
      value: '6',
      title: 'Clearing - Non THB'
    },
    {
      value: '7',
      title: 'Clearing - THB'
    },
    {
      value: '8',
      title: 'Advance Payment'
    },
    {
      value: '4',
      title: 'Net หนี้ - AP : GL Suspense Account for Adjustment'
    },
    {
      value: '5',
      title: 'Net หนี้: ตั้งยอดรอเงิน Net หนี้'
    }
  ];
}

export function ePoList() {
  return [
    {
      value: 'yes',
      title: 'Yes'
    },
    {
      value: 'no',
      title: 'No'
    }
  ];
}

export function poList() {
  return [
    {
      value: 'yes',
      title: 'Yes'
    },
    {
      value: 'no',
      title: 'No'
    }
  ];
}

export function OverallStatusList() {
  return [
    {
      value: 'Open',
      title: 'Open'
    },
    {
      value: 'BeingProcess',
      title: 'Being Process'
    },
    {
      value: 'Completed',
      title: 'Completed'
    }
  ];
}

export function StatusFollowingInvoice2() {
  return [
    {
      value: 'WaitingDoc',
      title: 'Waiting Doc'
    },
    {
      value: 'WaitingSendOS',
      title: 'Waiting Send OS'
    },
    {
      value: 'WaitingPresentBill',
      title: 'Waiting Present Bill'
    },
    {
      value: 'WaitingPayment',
      title: 'Waiting Payment'
    },
    {
      value: 'WaitingMatching',
      title: 'Waiting Matching'
    },
    {
      value: 'IncomingPayment',
      title: 'Incoming Payment'
    },
    {
      value: 'Completed',
      title: 'Completed (Paid)'
    },
    {
      value: 'CompletedSystem',
      title: 'Completed (Paid) By System'
    },
    {
      value: 'Cancel',
      title: 'Cancelled'
    }
    // {
    //   value: '7',
    //   title: 'Complete Payment'
    // }
  ];
}
export function StatusBillingStatus() {
  return [
    {
      value: 'WaitingCreate',
      title: 'Waiting to Create'
    },
    // {
    //   value: 'WaitingSendOS',
    //   title: 'Waiting to send OS'
    // },
    {
      value: 'WaitingSendCustomer',
      title: 'Waiting to send Customer'
    },
    {
      value: 'Completed',
      title: 'Completed'
    },
    {
      value: 'Cancelled',
      title: 'Cancelled'
    }
  ];
}

export function SelectTypeDateTypeOverdueReport() {
  return [
    {
      value: 'Duedate',
      title: 'Due date'
    },
    {
      value: 'AppointmentDate',
      title: 'Appointment Date'
    },
    {
      value: 'CreatedDate',
      title: 'Create Date'
    }
  ];
}

export function SelectReportTypeForOverdueReport() {
  return [
    {
      value: '',
      title: 'All'
    },
    {
      value: 'OverdueDate',
      title: 'นัดชำระเกินกติกา'
    },
    {
      value: 'Overdue',
      title: 'Overdue'
    }
  ];
}
export function SelectTypeEmailFlow() {
  return [
    {
      value: 'Credit',
      title: 'Credit'
    },
    {
      value: 'Sales',
      title: 'Sales'
    }
  ];
}
export function DocumentTypePlanBill() {
  return [
    {
      value: 'InvoiceNo',
      title: 'Invoice No.'
    },
    {
      value: 'DocumentNo',
      title: 'Document No.'
    },
    {
      value: 'BillPresentmentNo',
      title: 'Bill Presentment No'
    },
    {
      value: 'ReceiptNo',
      title: 'Receipt No'
    }
  ];
}
export function DocumentTypeDailyFile() {
  return [
    {
      value: 'invoiceNo',
      title: 'Invoice No.'
    },
    {
      value: 'billingNo',
      title: 'Bill Presentment No'
    },
    {
      value: 'chequeNo',
      title: 'Cheque No.'
    },
    {
      value: 'receiptNo',
      title: 'Receipt No'
    },
    {
      value: 'docNo',
      title: 'Document No.'
    }
  ];
}
export function SelectTypePlanBill() {
  return [
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Bill Presentment Date',
      title: 'Bill Presentment Date'
    },
    {
      value: 'Issue Date',
      title: 'Issue Date'
    },
    {
      value: 'Cus Due',
      title: 'Cus Due'
    },
    {
      value: 'YBill Date',
      title: 'YBill Date'
    },
    {
      value: 'New YBill Date',
      title: 'New YBill Date'
    },
    {
      value: 'ApproveDate',
      title: 'Approve Inv&DP Date'
    }
  ];
}
export function SelectTypePlanCheque() {
  return [
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Bill Presentment Date',
      title: 'Bill Presentment Date'
    },
    {
      value: 'Issue Date',
      title: 'Issue Date'
    },
    {
      value: 'Cus Due',
      title: 'Cus Due'
    },
    {
      value: 'YCol Date',
      title: 'YCol Date'
    },
    {
      value: 'Pay Date',
      title: 'Pay Date'
    },
    {
      value: 'ApproveDate',
      title: 'Approve Inv&DP Date'
    }
  ];
}
export function DefaultCustomerAddress() {
  return [
    {
      title: 'Present Bill',
      value: 'PresentBill',
      address: null
    },
    { title: 'CN/DN', value: 'CNDN', address: null },
    { title: 'Receive PO', value: 'ReceivePO', address: null },
    {
      title: 'Receipt Cheque',
      value: 'ReceiptCheque',
      address: null
    },
    { title: 'Send Receipt', value: 'SendReceipt', address: null },
    { title: 'WHT', value: 'WHT', address: null }
  ];
}

export function DefaultCustomerContact() {
  return [
    {
      title: 'Present Bill',
      value: 'ContactPresentBill',
      contact: null
    },
    { title: 'CN/DN', value: 'ContactCNDN', contact: null },
    { title: 'Receive PO', value: 'ContactReceivePO', contact: null },
    {
      title: 'Contact Payment',
      value: 'ContactPayment',
      contact: null
    },
    { title: 'Send Receipt', value: 'ContactSendReceipt', contact: null },
    { title: 'WHT', value: 'ContactWHT', contact: null }
  ];
}

export function SelectTypeDocumentTypeSearchLateCharge() {
  return [
    {
      value: 'InvoiceNo',
      title: 'Invoice No.'
    },
    // {
    //   value: 'ReceiptNo',
    //   title: 'Receipt No'
    // }
    {
      value: 'ReportNo',
      title: 'Report No.'
    },
    {
      value: 'LateChargeNo',
      title: 'Late Charge No.'
    }
  ];
}

export function SelectTypeDateTypeSearchLateCharge() {
  return [
    // {
    //   value: 'InvoiceDate',
    //   title: 'Invoice Date'
    // },
    {
      value: 'Duedate',
      title: 'Cus Due Date'
    },
    // {
    //   value: 'NextDate',
    //   title: 'Next Pay Date'
    // }
    {
      value: 'Documentdate',
      title: 'Document Date'
    },
    {
      value: 'Paiddate',
      title: 'Paid Date'
    }
  ];
}

export function SelectTypeStatusLateCharge() {
  return [
    {
      value: 'Open',
      title: 'Open'
    },
    {
      value: 'OnProcess',
      title: 'On Process'
    },
    {
      value: 'Approve',
      title: 'อนุมัติเรียกเก็บ'
    },
    {
      value: 'Disapprove',
      title: 'อนุมัติไม่เรียกเก็บ'
    },
    {
      value: 'Cancelled',
      title: 'Cancelled'
    }
  ];
}

export function SelectTypeStatusLateChargeSale() {
  return [
    {
      value: 'OnProcess',
      title: 'On Process'
    },
    {
      value: 'Approve',
      title: 'อนุมัติเรียกเก็บ'
    },
    {
      value: 'Disapprove',
      title: 'อนุมัติไม่เรียกเก็บ'
    },
    {
      value: 'Cancelled',
      title: 'Cancelled'
    }
  ];
}

export function SelectApproveStage() {
  return [
    {
      value: 'Waiting for Others approve',
      title: "Waiting for Other's approve"
    },
    {
      value: 'Waiting for your approve',
      title: 'Waiting for your approve'
    },
    {
      value: 'Completed',
      title: 'Completed'
    },
    {
      value: 'Cancelled',
      title: 'Cancelled'
    }
  ];
}

export function PaymentStatusIncommingExport() {
  return [
    {
      value: 'Open',
      title: 'Open'
    },
    {
      value: 'WaitingForConfirmEOT',
      title: 'Waiting for confirm (EOT)'
    },
    {
      value: 'WaitingCreditAdvice',
      title: 'Waiting Credit Advice'
    },
    {
      value: 'WaitingConfirmCreditAdvice',
      title: 'Waiting Confirm Credit Advice'
    },
    {
      value: 'ConfirmPayment',
      title: 'Confirm Payment'
    },
    {
      value: 'IncomingPayment',
      title: 'Incoming Payment'
    },
    {
      value: 'PaymentSuccess',
      title: 'Payment Success'
    },
    {
      value: 'Failed',
      title: 'Failed'
    },
    {
      value: 'Reversed',
      title: 'Reversed'
    },
    {
      value: 'ReverseSuccess',
      title: 'Reverse Success'
    },
    {
      value: 'UnconfirmEOT',
      title: 'Unconfirm (EOT)'
    },
    {
      value: 'Cancelled',
      title: 'Cancelled'
    }
  ];
}

export function StatusBillExport() {
  return [
    {
      value: 'NewBilling',
      title: 'New Billing'
    },
    {
      value: 'Success',
      title: 'Success'
    }
  ];
}

export function ExportFollowingPaymentResultType() {
  return [
    {
      value: 'false',
      title: 'Ungroup'
    },
    {
      value: 'true',
      title: 'Group'
    }
  ];
}

export function SelectDocumentTypeExportSearchProblem() {
  return [
    {
      value: 'ReportNo',
      title: 'Report No.'
    }
    // {
    //   value: 'PI',
    //   title: 'PI'
    // },
    // {
    //   value: 'EO',
    //   title: 'EO'
    // },
    // {
    //   value: 'ZF2',
    //   title: 'ZF2'
    // },
    // {
    //   value: 'ZF8',
    //   title: 'ZF8'
    // }
  ];
}
export function SelectTypeDateTypeExportSearchProblem() {
  return [
    {
      value: 'Duedate',
      title: 'Cus Due date'
    },
    {
      value: 'NextDate',
      title: 'Next Pay Date'
    },
    {
      value: 'CreateDate',
      title: 'Create Date'
    },
    {
      value: 'OverdueDate',
      title: 'Overdue Date'
    }
  ];
}
export function SelectTypeDateTypeExportOverdueReport() {
  return [
    {
      value: 'Duedate',
      title: 'Due date'
    },
    {
      value: 'AppointmentDate',
      title: 'Appointment Date'
    },
    {
      value: 'CreatedDate',
      title: 'Created Date'
    }
  ];
}

export function SelectTypeExportOverdueDay() {
  return [
    {
      value: '1-15',
      title: '1-15'
    },
    {
      value: '16-30',
      title: '16-30'
    },
    {
      value: '31-60',
      title: '31-60'
    },
    {
      value: '61-90',
      title: '61-90'
    },
    {
      value: '>90',
      title: 'มากกว่า 90'
    }
  ];
}
export function DocumentTypeChequeReturn() {
  return [
    {
      value: 'ChequeNo',
      title: 'Cheque No.'
    },
    {
      value: 'ChequeReturnNo',
      title: 'Cheque Return No.'
    },
    {
      value: 'IncomingNo',
      title: 'Transaction No.'
    }
  ];
}
export function DocumentTypeAddChequeReturn() {
  return [
    {
      value: 'TransactionNo',
      title: 'Transaction No.'
    },
    {
      value: 'ChequeNo',
      title: 'Cheque No.'
    },
    {
      value: 'InvoiceNo',
      title: 'Invoice No.'
    },
    {
      value: 'ReceiptNo',
      title: 'Receipt No'
    },
    {
      value: 'BillPresentmentNo',
      title: 'Bill Presentment No'
    }
  ];
}
export function StatusChequeReturn() {
  return [
    {
      value: 'Draft',
      title: 'Draft'
    },
    {
      value: 'Open',
      title: 'Open'
    },
    {
      value: 'Close',
      title: 'Close'
    },
    {
      value: 'Partial',
      title: 'Partial'
    },
    {
      value: 'WaitingToIncoming',
      title: 'Waiting To Incoming (Same Days)'
    },
    {
      value: 'WaitingUnblock',
      title: 'Waiting Unblock'
    },
    {
      value: 'Completed',
      title: 'Completed'
    }
  ];
}
export function SelectDateTypeChequeReturn() {
  return [
    {
      value: 'DocumentDate',
      title: 'Document Date'
    },
    {
      value: 'ChequeDate',
      title: 'Cheque Date'
    },
    {
      value: 'ChequeReturnDate',
      title: 'Cheque Return Date'
    }
  ];
}
export function SelectDateTypeChequeReturnAdd() {
  return [
    {
      value: 'ChequeDate',
      title: 'Cheque Date'
    },
    {
      value: 'TransactionDate',
      title: 'Transaction Date'
    },
    {
      value: 'ReceiptDate',
      title: 'Receipt Date'
    }
  ];
}
export function SelectSortTypeBillPresentment() {
  return [
    {
      value: 'BillingNo',
      title: 'Billing No'
    },
    {
      value: 'PONo',
      title: 'PO No'
    },
    {
      value: 'BillingDate',
      title: 'Billing Date'
    },
    {
      value: 'YcolYcalDate',
      title: 'Ycol/Ycal Date'
    },
    {
      value: 'Amount',
      title: 'Amount'
    }
  ];
}

export function ChannelList() {
  return [
    {
      value: '10',
      title: '10 - Domestic'
    },
    {
      value: '20',
      title: '20 - Agent Domestic'
    },
    {
      value: '30',
      title: '30 - Export'
    }
  ];
}

export function CountryList() {
  return [
    {
      value: 'TH',
      title: 'TH'
    },
    {
      value: 'NonTH',
      title: 'NonTH'
    }
  ];
}

export function LevelApprover() {
  return [
    {
      value: '1',
      title: 'Account Executive'
    },
    {
      value: '2',
      title: 'Account Manager'
    },
    {
      value: '3',
      title: 'Department Manager'
    },
    {
      value: '4',
      title: 'Division Manager'
    },
    {
      value: '5',
      title: 'Marketing Director'
    },
    {
      value: '6',
      title: 'Managing Director'
    }
  ];
}

export function ReportByList() {
  return [
    {
      value: 'BU',
      title: 'BU'
    },
    {
      value: 'Company',
      title: 'Company'
    },
    {
      value: 'SalesOrg',
      title: 'Sales Org'
    },
    {
      value: 'Industry',
      title: 'Industry'
    },
    {
      value: 'SalesGroup',
      title: 'Sales Group'
    }
  ];
}
export function SelectDocumentTypeUnblockOrder() {
  return [
    {
      value: 'InvoiceNo',
      title: 'Invoice No.'
    },
    // {
    //   value: 'BENo',
    //   title: 'B/E No.'
    // },
    {
      value: 'RequestCancelCreditBlockNo',
      title: 'Request Cancel Credit Block No.'
    },
    {
      value: 'ChequeReturnNo',
      title: 'Cheque Return No.'
    },
    {
      value: 'OverdueReportNo',
      title: 'Overdue Report No.'
    }
  ];
}

export function ReportTypeList() {
  return [
    {
      value: 'Credit Term',
      title: 'Credit Term'
    },
    {
      value: 'Est. Payment Period',
      title: 'Est. Payment Period'
    },
    {
      value: 'Actual Payment Period',
      title: 'Actual Payment Period'
    }
  ];
}
export function SelectDateTypeUnblockOrder() {
  return [
    {
      value: 'InvoiceDate',
      title: 'Invoice Date'
    },
    {
      value: 'CusDueDate',
      title: 'Cus Due Date'
    },
    {
      value: 'NextPayDate',
      title: 'Next Pay Date'
    },
    // {
    //   value: 'BEDate',
    //   title: 'B/E Date'
    // },
    {
      value: 'DocumentDate',
      title: 'Document Date'
    },
    {
      value: 'ChequeReturnDate',
      title: 'Cheque Return Date'
    },
    {
      value: 'OverdueReportDate',
      title: 'Overdue Report Date'
    }
  ];
}

export function CountryTypeList() {
  return [
    {
      value: false,
      title: 'Domestic'
    },
    {
      value: true,
      title: 'Export'
    }
  ];
}
export function TopicUnblockOrder() {
  return [
    {
      value: '1',
      title: 'เช็คคืน'
    },
    // {
    //   value: '2',
    //   title: 'หนี้เกินกำหนด'
    // },
    {
      value: '3',
      title: 'หนี้เกินกำหนด 30 วัน'
    },
    {
      value: '4',
      title: 'หนี้เกินกำหนด 60 วัน'
    },
    {
      value: '5',
      title: 'ขออนุมัติ Overdue ล่วงหน้าก่อน 30 วัน'
    }
    // {
    //   value: '6',
    //   title: 'ตั๋วคืน B/E'
    // }
  ];
}

export function CustomerTypeList() {
  return [
    {
      value: '0',
      title: 'External Customer'
    },
    {
      value: '1,2',
      title: 'Intercom Customer'
    }
  ];
}
export function StatusUnblockOrder() {
  return [
    {
      value: 'Open',
      title: 'Open'
    },
    {
      value: 'OnProcess',
      title: 'On Process'
    },
    {
      value: 'OnProcessPrint',
      title: 'On Process(Print)'
    },
    {
      value: 'Approved',
      title: 'Approved'
    },
    {
      value: 'Rejected',
      title: 'Rejected'
    },
    {
      value: 'ApprovedPO',
      title: 'Approved by P/O'
    },
    {
      value: 'WaitingUnblock',
      title: 'Waiting Unblock'
    },
    {
      value: 'Completed',
      title: 'Completed'
    },
    {
      value: 'Cancelled',
      title: 'Cancelled'
    },
    {
      value: 'Closed',
      title: 'Closed'
    }
  ];
}

export function StatusSalesRolesUnblockOrder() {
  return [
    {
      value: `Waiting for others approve`,
      title: `Waiting for other's approve`
    },
    {
      value: 'Waiting for your approve',
      title: 'Waiting for your approve'
    },
    {
      value: 'Completed',
      title: 'Completed'
    },
    {
      value: 'Cancelled',
      title: 'Cancelled'
    }
  ];
}

export function SnapStatus() {
  return [
    {
      value: true,
      title: 'Yes'
    },
    {
      value: false,
      title: 'No'
    }
  ];
}
export function StatusList() {
  return [
    {
      value: true,
      title: 'Active'
    },
    {
      value: false,
      title: 'Inactive'
    }
  ];
}
export function DomainList() {
  return [
    {
      value: 'cementhai',
      title: 'cementhai'
    },
    {
      value: 'scg.com',
      title: 'scg.com'
    },
    {
      value: 'scgp.co.th',
      title: 'scgp.co.th'
    },
    {
      value: 'ocg.scgpco.com',
      title: 'ocg.scgpco.com'
    },
    {
      value: 'fajarpaper.com',
      title: 'fajarpaper.com'
    },
    {
      value: 'prepack.scgpco.com',
      title: 'prepack.scgpco.com'
    },
    {
      value: 'dayasa.co.id',
      title: 'dayasa.co.id'
    }
  ];
}
export function RoleList() {
  return [
    {
      value: 'WH',
      title: 'WH'
    },
    {
      value: 'SCGL',
      title: 'Logistic'
    },
    {
      value: 'CREDIT_OFFICER',
      title: 'Credit Officer'
    },
    {
      value: 'CREDIT_STAFF',
      title: 'Credit Staff'
    },
    {
      value: 'CREDIT_MANAGER',
      title: 'Credit Manager'
    },
    {
      value: 'CREDIT_ADMIN',
      title: 'Credit Admin'
    },
    {
      value: 'CREDIT_DEPARTMENT_MANAGER',
      title: 'Credit Department Manager'
    },
    {
      value: 'SALES',
      title: 'Sales'
    },
    {
      value: 'SALES_MANAGER',
      title: 'Sales Manager'
    },
    {
      value: 'PD',
      title: 'PD'
    }
  ];
}
export const CompanyAuthorize = {
  View: 'View',
  Edit: 'Edit'
};

export const PageActivity = {
  All: 'All',
  Read: 'Read Only',
  No: 'No Permission'
};

export function YesNoOption() {
  return [
    {
      value: true,
      title: 'Yes'
    },
    {
      value: false,
      title: 'No'
    }
  ];
}
export function YesNoOption2() {
  return [
    {
      value: 'Yes',
      title: 'Yes'
    },
    {
      value: 'No',
      title: 'No'
    }
  ];
}

export const PageName = {
  Master: 'Master',
  Invoice_Management: 'Invoice Management',
  Document_Management: 'Document Management',
  Payment_Management: 'Payment Management',
  Work_Flow: 'Work Flow',
  Control_Management: 'Control Management',
  Risk_Management: 'Risk Management',
  Report: 'Report',
  Export_Payment: 'Export Payment',
  Configuration: 'Configuration',
  Cutoff_Document: 'Cutoff Document',
  Customer: 'Customer',
  Risk_Category: 'Risk Category',
  Bill_Collector: 'Bill Collector',
  Payment_Term: 'Payment Term',
  Customers_Bank: 'Customers Bank',
  Payment_Bank: 'Payment Bank',
  Incoming_GL: 'Incoming GL',
  Credit_Team: 'Credit Team',
  Credit_Team_Mapping: 'Credit Team Mapping',
  Bill_Method: 'Bill Method',
  Payment_Type: 'Payment Type',
  SCG_Holiday: 'SCG Holiday',
  Bank_Holiday: 'Bank Holiday',
  Main_Sales_Employee: 'Main Sales Employee',
  Email_Group: 'E-mail Group',
  Config_Email: 'Config E-mail',
  Main_Sales_Group_Sales_Office: 'Main Sales Group Sales Office',
  SelectIn_SelectOut: 'Select-In / Select-Out',
  Insurance_Company: 'Insurance Company',
  Snap_Credit_Master: 'Snap Credit Master',
  Users: 'Users',
  Invoice_AND_DP_for_Logistic_WH: 'Invoice & DP for Logistic WH',
  Following_PO: 'Following PO',
  Following_Invoice: 'Following Invoice',
  Outsource: 'Outsource',
  NewOutsource: 'Outsource',
  Calling_AND_Daily: 'Calling & Daily',
  BU_Messenger: 'BU Messenger',
  Email: 'E-mail',
  EMS: 'EMS',
  CustomerSystem: 'Customer System',
  Bill_Presentment_AND_Invoice: 'Bill Presentment & Invoice',
  Receipt: 'Receipt',
  Bill_Of_Exchange: 'Bill Of Exchange',
  Domestic_Letter_Of_Credit: 'Domestic Letter Of Credit',
  Following_Payment: 'Following Payment',
  Incoming_Payment: 'Incoming Payment',
  Search_Problem: 'Search Problem',
  GL_Statement: 'G/L Statement',
  Cheque_Return: 'Cheque Return',
  Late_Charge: 'Late Charge',
  Postpone_Cheque: 'Postpone Cheque',
  Request_Cancel_Credit_Block: 'Request Cancel Credit Block',
  Questionnaires: 'Questionnaires',
  Highlight_Overdue: 'Highlight Overdue',
  Insurance: 'Insurance',
  Debenture: 'Debenture',
  Plan_Cash_In_Flow: 'Plan Cash In Flow',
  Overdue_Report: 'Overdue Report',
  Late_Charge_Report: 'Late Charge Report',
  Cheque_Return_Report: 'Cheque Return Report',
  Sales_Volume_by_Credit_Term: 'Sales Volume by Credit Term',
  KPI_Overdue: 'KPI Overdue',
  SCGP_Management_Committee: 'SCGP Management Committee',
  Upload_Data: 'Upload Data',
  Following_Payment_Export: 'Following Payment Export',
  Incoming_Payment_Export: 'Incoming Payment Export',
  Search_Problem_Export: 'Search Problem Export',
  Overdue_Report_Export: 'Overdue Report Export',
  Credit_Advice: 'Credit Advice',
  Header: 'Header',
  Highlight_Information: 'Highlight Information',
  Control_AND_Risk: 'Control & Risk',
  Bill_Collector_Bill_AND_Payment: 'Bill Collector : Bill & Payment',
  Bill_Collector_Customer_Calendar__YbillYcolYcal: 'Bill Collector : Customer Calendar - Ybill/Ycol/Ycal',
  Bill_Collector_Customer_Calendar__Customer_Holiday: 'Bill Collector : Customer Calendar - Customer Holiday',
  Bill_Collector_Contact_AND_Address: 'Bill Collector : Contact & Address',
  Bill_Collector_Other: 'Bill Collector : Other',
  Bill_Collector_Email: 'Bill Collector : Email',
  Bill_Collector_Partner: 'Bill Collector : Partner',
  Bill_Collector_Attach_file: 'Bill Collector : Attach file',
  Role: 'Role'
};

export function DocStatus() {
  return [
    {
      value: 'NoAttach',
      title: 'No Attach'
    },
    {
      value: 'Waiting',
      title: 'Waiting'
    },
    {
      value: 'Completed',
      title: 'Completed'
    }
  ];
}

export function SelectTypeDateForOS() {
  return [
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Bill Presentment Date',
      title: 'Bill Presentment Date'
    },
    {
      value: 'Cutoff Date',
      title: 'Cutoff Date'
    },
    {
      value: 'YBill',
      title: 'YBill'
    },
    {
      value: 'YBill Notify Date',
      title: 'YBill Notify Date'
    },
    {
      value: 'YCol',
      title: 'YCol'
    },
    {
      value: 'YCol Notify Date',
      title: 'YCol Notify Date'
    },
    {
      value: 'YCal',
      title: 'YCal'
    },
    {
      value: 'YCal Notify Date',
      title: 'YCal Notify Date'
    },
    {
      value: 'PayDate',
      title: 'Pay Date'
    },
    {
      value: 'Send Date',
      title: 'Send Date'
    },
    {
      value: 'Cheque Date',
      title: 'Cheque Date'
    },
    {
      value: 'Document Date',
      title: 'Document Date'
    },
    {
      value: 'New YBill',
      title: 'New YBill'
    },
    {
      value: 'OsDate',
      title: 'OS Date'
    },
    {
      value: 'ReceiptDate',
      title: 'Receipt Date'
    },
    {
      value: 'ApproveDate',
      title: 'Approve Inv&DP Date'
    }
  ];
}

export function ScgOsStatus() {
  return [
    {
      value: 'Waiting',
      title: 'Waiting'
    },
    {
      value: 'Confirm',
      title: 'Confirm'
    },
    {
      value: 'Add',
      title: 'Add'
    },
    {
      value: 'Delete',
      title: 'Delete'
    }
  ];
}

export function SortBy() {
  return [
    {
      value: 'Ascending',
      title: 'Ascending'
    },
    {
      value: 'Descending',
      title: 'Descending'
    }
  ];
}

export function CallingRowType() {
  return [
    {
      value: 'OS',
      title: 'OS'
    },
    {
      value: 'SCG',
      title: 'SCG'
    }
  ];
}

export function SelectTypeDateForCS() {
  return [
    {
      value: 'Invoice Date',
      title: 'Invoice Date'
    },
    {
      value: 'Bill Presentment Date',
      title: 'Bill Presentment Date'
    },
    {
      value: 'Cutoff Date',
      title: 'Cutoff Date'
    },
    {
      value: 'YBill',
      title: 'YBill'
    },
    {
      value: 'YBill Notify Date',
      title: 'YBill Notify Date'
    },
    {
      value: 'YCol',
      title: 'YCol'
    },
    {
      value: 'YCol Notify Date',
      title: 'YCol Notify Date'
    },
    {
      value: 'YCal',
      title: 'YCal'
    },
    {
      value: 'YCal Notify Date',
      title: 'YCal Notify Date'
    },
    {
      value: 'PayDate',
      title: 'Pay Date'
    },
    {
      value: 'Send Date',
      title: 'Send Date'
    },
    {
      value: 'Cheque Date',
      title: 'Cheque Date'
    },
    {
      value: 'Document Date',
      title: 'Document Date'
    },
    {
      value: 'New YBill',
      title: 'New YBill'
    },
    {
      value: 'ReceiptDate',
      title: 'Receipt Date'
    },
    {
      value: 'ApproveDate',
      title: 'Approve Inv&DP Date'
    }
  ];
}

export function InvAndDpSpecialCondition() {
  return [
    {
      value: 'โกดังไม่แนบ',
      title: 'โกดังไม่แนบ'
    },
    {
      value: 'E-DP',
      title: 'E-DP'
    }
  ];
}

export function Factoring() {
  return [
    { value: true, title: 'Yes' },
    { value: false, title: 'No' }
  ];
}
export function SendEmailStatus() {
  return [
    {
      value: 'Waiting',
      title: 'Waiting'
    },
    // {
    //   value: 'Sending',
    //   title: 'Sending'
    // },
    {
      value: 'Sent',
      title: 'Sent'
    }
    // {
    //   value: 'Failed',
    //   title: 'Failed'
    // }
  ];
}

export function StatusReceiptStatus() {
  return [
    {
      value: 'WaitingCreate',
      title: 'Waiting to Create'
    },
    // {
    //   value: 'WaitingSendOS',
    //   title: 'Waiting to send OS'
    // },
    {
      value: 'WaitingSendCustomer',
      title: 'Waiting to send Customer'
    },
    {
      value: 'Completed',
      title: 'Completed'
    },
    {
      value: 'CompletedSystem',
      title: 'Completed (By System)'
    },
    {
      value: 'Cancelled',
      title: 'Cancelled'
    }
  ];
}
